import {createSelector} from '@reduxjs/toolkit';
import {useSelector} from 'react-redux';
import {baseSelector, useSliceDispatch} from '../../utils';
import {RootState} from '../../store';
import {CastSliceState} from './types';
import {CastActions} from './actions';

export const useCastDispatch = () => useSliceDispatch<CastActions>();

export const selectCastSlice = createSelector(
    [
        (state: RootState) => state.cast,
        (state: RootState, keys: (keyof CastSliceState)[]) => keys,
    ],
    // Defensive: if `cast` is missing from state for any reason (transient
    // rehydration window, store rebuild, etc.), return empty so consumers
    // get `undefined` for each key instead of crashing during destructure.
    (slice, keys) => slice ? baseSelector(slice, keys)() : ({} as Partial<CastSliceState>),
);

export const useCastSelector = (keys: (keyof CastSliceState)[]) => {
    return useSelector((state: RootState) => selectCastSlice(state, keys));
};
